<template>
    <div class="editor-wrap">
        <template v-if="isFocus">
            <textarea v-model="editorData" :id="editorId"></textarea>
            <a-button class="preview" type="link" icon="read" @click="handlePreview" />
        </template>

        <div class="input" @click="handleFocus" v-else>
            <div class="label">{{ label }}</div>
            <div class="data" v-html="value" />
        </div>
    </div>
</template>


<script>
import CKEDITOR from "CKEDITOR";
export default {
    props: {
        value: String,
        label: String,
    },
    data() {
        return {
            isFocus: false,

            editor: null,
            editorId: `ck-${parseInt(Math.random() * 1000000)}`,
            editorData: "",
        };
    },
    mounted() {
        this.editorData = this.value;
    },
    methods: {
        handleFocus() {
            this.isFocus = true;

            this.$nextTick(() => {
                this.editor = CKEDITOR.replace(this.editorId, {
                    extraPlugins: ['kityformula', 'insertImage']
                });

                this.editor.on("change", () => {
                    this.editorData = this.editor.getData();
                });
            });
        },
        handlePreview() {
            this.isFocus = false;
            this.editor.destroy();
        },
    },
    watch: {
        value(val) {
            this.editorData = val;
        },
        editorData(val) {
            this.$emit("input", val);
        },
    },
};
</script>

<style lang="less" scoped>
.editor-wrap {
    position: relative;
    width: 100%;
    overflow: hidden;

    .preview {
        color: #333;
        position: absolute;
        top: 0;
        right: 2rem;
        font-size: 20px;
    }
}

.input {
    display: flex;
    min-height: 32px;
    border: 1px dashed #e8e8e8;
    padding: 1rem;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        border-color: #1890ff;
    }

    .label {
        width: 3.125rem;
        text-align: right;
        color: rgba(0, 0, 0, 0.35);

        &::after {
            content: ":";
            margin-left: 0.2em;
        }
    }

    .data {
        flex: 1;
        margin-left: 1em;
        overflow: hidden;
    }
}
</style>